import {
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import React from "react";
import { addContactV2Style } from "./AddContactV2Style";
import { PHONE_TYPES } from "../../constants/CoreConstants";
import { DeleteForever } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Utils from "../addContact/Utils";
import { PlusIcon } from "../common/Icons";
import Creatable from 'react-select/creatable';
import BasicFormControlWithLabelV2 from "../custom/BasicFormControlWithLabelV2";
import {BasicMaskedInput} from "../GlobalAddDealModalV3/GlobalAddDealModalStyles";
import BasicSelect from "../custom/BasicSelect";
import BasicInput from "../custom/BasicInput";

const RelatedContactInfo = ({
  relatedContactsRef,
  contactForm,
  setContactForm,
}) => {
  const classes = addContactV2Style();
  const defaultRelatedContact = {
    relationship: "",
    first_name: "",
    last_name: "",
    numbers: [{ number: "", number_state: "" }],
    emails: [{ email: "" }],
    birth_date: "",
  };
  const defaultRelationshipOptions = [
  { value: "Co-insured", label: "Co-insured" },
  { value: "Spouse", label: "Spouse" },
  { value: "Child", label: "Child" },
  { value: "Household member", label: "Household member" },
];
  const placeholderColor = "#929da9";
  const activeColor = "#36454F";

  const addRelatedContact = () => {
    setContactForm((prev) => ({
      ...prev,
      related_contacts: [
        ...prev.related_contacts,
        { ...defaultRelatedContact },
      ],
    }));
  };

  const removeRelatedContact = (indexToRemove) => {
    setContactForm((prev) => ({
      ...prev,
      related_contacts: prev.related_contacts.filter(
        (_, idx) => idx !== indexToRemove
      ),
    }));
  };

  const appendNumber = (relIndex) => {
    const numberObj = {
      number: "",
      number_state: "",
    };

    setContactForm((prev) => {
      const updatedRelatedContacts = [...prev.related_contacts];
      const updatedNumbers = [
        ...updatedRelatedContacts[relIndex].numbers,
        numberObj,
      ];

      updatedRelatedContacts[relIndex] = {
        ...updatedRelatedContacts[relIndex],
        numbers: updatedNumbers,
      };

      return {
        ...prev,
        related_contacts: updatedRelatedContacts,
      };
    });
  };

  const appendEmail = (relIndex) => {
    const emailObj = { email: "" };

    setContactForm((prev) => {
      const updatedRelatedContacts = [...prev.related_contacts];
      const updatedEmails = [
        ...updatedRelatedContacts[relIndex].emails,
        emailObj,
      ];

      updatedRelatedContacts[relIndex] = {
        ...updatedRelatedContacts[relIndex],
        emails: updatedEmails,
      };

      return {
        ...prev,
        related_contacts: updatedRelatedContacts,
      };
    });
  };

  const removeMultiField = (fieldName, fieldIndex, relIndex) => {
    setContactForm((prev) => {
      const updatedRelatedContacts = [...prev.related_contacts];
      const updatedFieldArray = [
        ...updatedRelatedContacts[relIndex][fieldName],
      ];

      updatedFieldArray.splice(fieldIndex, 1);

      updatedRelatedContacts[relIndex] = {
        ...updatedRelatedContacts[relIndex],
        [fieldName]: updatedFieldArray,
      };

      return {
        ...prev,
        related_contacts: updatedRelatedContacts,
      };
    });
  };

  const handleChange = (fieldName, value, relIndex) => {
    setContactForm((prev) => {
      const updatedRelatedContacts = [...prev.related_contacts];
      updatedRelatedContacts[relIndex] = {
        ...updatedRelatedContacts[relIndex],
        [fieldName]: value,
      };

      return {
        ...prev,
        related_contacts: updatedRelatedContacts,
      };
    });
  };

  const handleChangeDynamicInput = (field, key, value, index, relIndex) => {
    if (field === "numbers" && key === "number") {
      if (!Utils.checkLetterExistInText(value) || value === "") {
        if (value.length > 0 && value[0] !== "1") {
          value = "1" + value;
        }
      } else {
        try {
          value = value.replace(/[^0-9]/g, "");
          if (value.length > 0 && value[0] !== "1") {
            value = "1" + value;
          }
        } catch (e) {
          console.error(e);
        }
      }

      if (value.length > 11) {
        value = value.slice(0, 11);
      }
    }

    setContactForm((prev) => {
      const updatedRelatedContacts = [...prev.related_contacts];
      const targetGroup = [...updatedRelatedContacts[relIndex][field]];

      targetGroup[index] = {
        ...targetGroup[index],
        [key]: value,
      };

      updatedRelatedContacts[relIndex] = {
        ...updatedRelatedContacts[relIndex],
        [field]: targetGroup,
      };

      return {
        ...prev,
        related_contacts: updatedRelatedContacts,
      };
    });
  };

const customEmailPersonalizedStyle = {
  control: (provided) => ({
    ...provided,
    minHeight: "37.5px !important",
    height: "37.5px !important",
    border: "1px solid #ced4da !important", 
    boxShadow: "none !important",            
    "&:hover": {
      border: "1px solid #ced4da !important", 
      color: "#133159 !important"
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "37.5px !important",
    padding: "0 8px !important",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px !important",
    padding: "0px !important",
    color: "#133159 !important"
  }),
   singleValue: (provided) => ({
    ...provided,
   color: "#133159 !important"
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "37.5px !important",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "rgba(8, 40, 82, 0.44) !important", 
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    backgroundColor: state.isFocused
      ? "#cbd4ff !important" 
      : state.isSelected
      ? "#cbd4ff !important"
      : "white !important",
    color:
      state.isFocused || state.isSelected
        ? "#133159 !important"
        : "#133159 !important",
    "&:active": {
      backgroundColor: "#cbd4ff !important",
      color: "#133159 !important",
    },
  }),
};

  return (
    <>
      {
        <Grid
          container
          spacing={2}
          style={{ paddingInline: 5, marginBottom: "48px" }}
        >
          <Grid item xs={12}>
            <div
              ref={relatedContactsRef}
              data-section="Related Contacts"
              style={{ width: "100%" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    paddingRight: "10px",
                  }}
                >
                  <Typography variant="body2" className={classes.titleStyle}>
                    Related Contacts
                  </Typography>
                </div>

                <div style={{ width: "100%" }}>
                  <Divider />
                </div>
              </div>
            </div>
          </Grid>

          {contactForm.related_contacts.map((relatedContact, relIndex) => (
            <Grid item xs={12} key={relIndex}>
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "16px",
                  marginBottom: "12px",
                  position: "relative",
                }}
              >
                {relIndex > 0 && (
                  <IconButton
                    size="small"
                    onClick={() => removeRelatedContact(relIndex)}
                    style={{ position: "absolute", top: 8, right: 8 }}
                  >
                    <DeleteForever color="error" />
                  </IconButton>
                )}

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        width: "49%",
                      }}
                    >
                        <BasicFormControlWithLabelV2
                            label={'Relationship to Insured'}
                            styles={customEmailPersonalizedStyle}
                            isClearable={false}
                            placeholder="Select Relationship"
                            options={defaultRelationshipOptions}
                            value={relatedContact.relationship
                                ? { value: relatedContact.relationship, label: relatedContact.relationship }
                                : ""}
                            onChange={(newValue) => {
                                if (typeof newValue === "string") {
                                    handleChange("relationship", newValue, relIndex);
                                } else if (newValue) {
                                    handleChange("relationship", newValue.value, relIndex);
                                } else {
                                    handleChange("relationship", "", relIndex);
                                }
                            }}
                            isMulti={false}
                            component={Creatable}
                            sx={{
                                '& div': {
                                    border: 'none !important'
                                },
                                '& div:hover': {
                                    border: 'none !important'
                                }
                            }}
                        />
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6}>
                      <BasicFormControlWithLabelV2
                          label={'First Name'}
                          name={`relatedContacts[${relIndex}].firstName`}
                          fullWidth
                          value={relatedContact.first_Name}
                          onChange={(e) =>
                              handleChange("first_name", e.target.value, relIndex)
                          }
                          component={BasicInput}
                          sx={{
                              '& .MuiInputBase-root': {
                                  marginTop: 0,
                              },
                              '& input': {
                                  border: 'none !important'
                              }
                          }}
                      />
                  </Grid>

                  <Grid item xs={12} md={6}>
                      <BasicFormControlWithLabelV2
                          label={'Last Name'}
                          name={`relatedContacts[${relIndex}].lastName`}
                          fullWidth
                          value={relatedContact.last_name}
                          onChange={(e) =>
                              handleChange("last_name", e.target.value, relIndex)
                          }
                          component={BasicInput}
                          sx={{
                              '& .MuiInputBase-root': {
                                  marginTop: 0,
                              },
                              '& input': {
                                  border: 'none !important'
                              }
                          }}
                      />
                  </Grid>

                  {relatedContact.numbers.map((number, numIndex) => (
                    <Grid item xs={12} key={numIndex}>
                      <Grid container spacing={2}>
                        <Grid item xs={6} className="mask-numbr-input">
                            <BasicFormControlWithLabelV2
                                label={'Phone Number'}
                                fullWidth
                                mask={[
                                    "+",
                                    /\d/,
                                    " ",
                                    "(",
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    ")",
                                    " ",
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    "-",
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                className={`${classes.phoneNumberInput} MuiInputBase-input`}
                                // guide={true}
                                // keepCharPositions={true}
                                id={"number-input-field" + numIndex}
                                onChange={(e) =>
                                    handleChangeDynamicInput(
                                        "numbers",
                                        "number",
                                        e.target.value,
                                        numIndex,
                                        relIndex
                                    )
                                }
                                value={number.number}
                                component={BasicMaskedInput}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        marginTop: 0,
                                    },
                                    '& input': {
                                        border: 'none !important'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                          <div style={{ display: "flex", gap: "10px" }}>
                              <BasicSelect
                                  fullWidth
                                  name="numberState"
                                  options={PHONE_TYPES}
                                  value={number.number_state}
                                  mapping={{ label: "label", value: "value" }}
                                  defaultText="Please Select"
                                  onChange={(e) =>
                                      handleChangeDynamicInput(
                                          "numbers",
                                          "number_state",
                                          e.target.value,
                                          numIndex,
                                          relIndex
                                      )
                                  }
                              />
                            {numIndex === 0 ? (
                              <div
                                className={classes.addButtonStyle}
                                onClick={() => appendNumber(relIndex)}
                              >
                                <PlusIcon fill="#FFF" />
                              </div>
                            ) : (
                              <IconButton
                                size="small"
                                onClick={() =>
                                  removeMultiField(
                                    "numbers",
                                    numIndex,
                                    relIndex
                                  )
                                }
                              >
                                <DeleteForever color="error" />
                              </IconButton>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}

                  {relatedContact.emails.map((email, emailIndex) => (
                    <Grid item xs={12} key={emailIndex}>
                      <div style={{ display: "flex", gap: "10px" }}>
                          <BasicFormControlWithLabelV2
                              label={'Email'}
                              type="email"
                              fullWidth
                              value={email.email}
                              onChange={(e) =>
                                  handleChangeDynamicInput(
                                      "emails",
                                      "email",
                                      e.target.value,
                                      emailIndex,
                                      relIndex
                                  )
                              }
                              component={BasicInput}
                              sx={{
                                  '& .MuiInputBase-root': {
                                      marginTop: 0,
                                  },
                                  '& input': {
                                      border: 'none !important'
                                  }
                              }}
                          />
                        {emailIndex === 0 ? (
                          <div
                            className={classes.addButtonStyle}
                            onClick={() => appendEmail(relIndex)}
                          >
                            <PlusIcon fill="#FFF" />
                          </div>
                        ) : (
                          <IconButton
                            size="small"
                            onClick={() =>
                              removeMultiField("emails", emailIndex, relIndex)
                            }
                          >
                            <DeleteForever color="error" />
                          </IconButton>
                        )}
                      </div>
                    </Grid>
                  ))}

                  <Grid item xs={12} md={6}>
                      <BasicFormControlWithLabelV2
                          label={'Date of Birth'}
                          type="date"
                          fullWidth
                          style={{color: contactForm.birth_date ? activeColor : placeholderColor}}
                          name={`relatedContacts[${relIndex}].dateOfBirth`}
                          value={relatedContact.dateOfBirth}
                          onChange={(e) =>
                              handleChange("birth_date", e.target.value, relIndex)
                          }
                          component={BasicInput}
                          sx={{
                              '& .MuiInputBase-root': {
                                  marginTop: 0,
                              },
                              '& input': {
                                  border: 'none !important'
                              }
                          }}
                      />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          ))}

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              disableElevation
              startIcon={<AddIcon />}
              onClick={addRelatedContact}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      }
    </>
  );
};

export default RelatedContactInfo;
